import { frontendURL } from '../../../helper/URLHelper';

import Takvim from './Takvim.vue';

// Temsilci de takvimi gorebilmeli: hatirlatma ve randevu gundelik bir is,
// her seferinde yoneticiyi beklemek isi durdurur. Kimin hangi kaydi
// gorecegi sunucuda hesap kapsaminda zaten sinirli.
const YETKI = { permissions: ['administrator', 'agent'] };

// Tek ekran, tek rota: menude de tek bir "Takvim" maddesi var. Alt sekme
// (ay / liste) ekranin ust bandinda duruyor; gorunum secimi icin ayri rota
// acmak geri tusunu anlamsiz bir gecmisle doldururdu.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/takvim'),
    name: 'takvim_index',
    component: Takvim,
    meta: YETKI,
  },
];
